export const SignatureBlock = ({
  label = "Signature du client",
  url = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbo5vHVMslUWKEwyzv1fKkXh3wg6yFdqzbWw&s",
}: {
  label?: string;
  url?: string;
}) => {
  return (
    <div className="border rounded-lg p-2 w-full ">
      <div className="text-neutral-400 text-h3">{label}</div>
      <img src={url} className="w-full h-80 object-contain object-left"></img>
    </div>
  );
};
